import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs/internal/Observable';
import { io, Socket } from "socket.io-client";
import { socketUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SocketService {

  private socket: Socket;
  private joinedRooms: string[] = [];

  constructor(
    private platform: Platform
  ) {

    this.socket = io(socketUrl, {
      // extraHeaders: {
      //   "ngrok-skip-browser-warning": "1234" // WARN: this will be ignored in a browser
      // }
    });

  
    this.socket.on("connect", () => {
      this.rejoinRooms()
    });

    this.socket.on("connect_error", (err) => {
      console.log('connected error')
    });

    this.platform.resume.subscribe(async () => {
      this.rejoinRooms()
    });

  }

  emit(event: string, data: any) {
    this.socket.emit(event, data);
  }

  on(event: string): Observable<any> {
    return new Observable((observer) => {
      this.socket.on(event, (data) => {
        observer.next(data);
      });

      // Handle cleanup
      return () => {
        this.socket.off(event);
      };
    });
  }

  joinRoom(x) {
    this.joinedRooms.push(x)
    this.socket.emit('joinRoom', (x));
  }

  leaveAllRooms(): void {
    let tempRooms = this.joinedRooms
    this.joinedRooms = []
    tempRooms.forEach((room: string) => {
      this.socket.emit('leaveRoom', (room));
    });
  }

  leaveRoom(room): void {
    this.socket.emit('leaveRoom', (room));
    let index = this.joinedRooms.findIndex(r => r == room);
    this.joinedRooms.splice(index, 1)
  }

  rejoinRooms() {
    this.joinedRooms.forEach((room: string) => {
      this.socket.emit('joinRoom', (room));
    });
  }
}
